import React from 'react'

const Item = ({ ...props }) => {
	console.log(props)
	return (
		<div className='flex justify-between'>
			<p className=' font-medium tracking-wide'>{props.name}</p>
			<p className=' font-medium tracking-wide'>{'₹ ' + props.price}</p>
		</div>
	)
}

export default Item
